/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { DetailedPatientState } from './types'
import { DetailedPatientActionNames, DetailedPatientMutationNames } from './keys'
import { getters } from './getters'
import { getDetailedPatientByIdQuery } from '@/jsonapi/DetailedPatient'
import { addOrUpdateSameKeyObjectInArray } from '@/store/utils/api'

const state: DetailedPatientState = {
  patients: [],
}

const mutations = {
  [DetailedPatientMutationNames.updatePatients](state, payload): void {
    state.patients = payload
  },
}

const actions = {
  async [DetailedPatientActionNames.getDetailedPatientById](
    { commit },
    { patientId }: { patientId: string }
  ): Promise<void> {
    try {
      const results = camelcaseKeysDeep(await getDetailedPatientByIdQuery(patientId))
      if (!results.length) {
        return
      }
      const newPatients = addOrUpdateSameKeyObjectInArray(state.patients, results[0], 'id')
      commit(DetailedPatientMutationNames.updatePatients, newPatients)
    } catch (e) {
      console.log(e)
    }
  },
}

export default {
  name: ModuleNames.detailedPatient,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
